import { render, staticRenderFns } from "./TournamentsMain.vue?vue&type=template&id=424496ae&scoped=true"
import script from "./TournamentsMain.vue?vue&type=script&lang=js"
export * from "./TournamentsMain.vue?vue&type=script&lang=js"
import style0 from "./TournamentsMain.vue?vue&type=style&index=0&id=424496ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424496ae",
  null
  
)

export default component.exports